export default __webpack_public_path__ + "static/media/img_baseBunnyRattle_rose_p.dbe53d34.jpg";